module.exports = __webpack_public_path__ + "static/img/3.14ca2ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/3.jpg
// module id = WcC9
// module chunks = 21